module.exports = __webpack_public_path__ + "static/images/components/Confirmation/images/background.4716733e.png";


//////////////////
// WEBPACK FOOTER
// ./components/Confirmation/images/background.png
// module id = 2594
// module chunks = 11